import React, { useCallback, useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import ReactTable from 'components/ReactTable';
import { sharedReactTableProps } from "../../../../utils/constant";
import { useDispatch, useSelector } from 'react-redux';
import { actions as customFieldActions, selectors as customFieldSelectors } from "store/modules/customFields";
import classNames from 'classnames';
import columns from "../helper/employerColumnProps";
import { useParams } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    tableWrapper: {
        width: "100%",
        overflow: "auto"
    },
    label: {
        width: 'fit-content',
        "& .MuiFormControlLabel-label": {
            color: theme.palette.text.primary
        }
    }
}));

export default function EmployerList(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const employersData = useSelector((state) => customFieldSelectors.getDetailEmployerListData(state, { part: "data" }));
    const pageFilter = useSelector((state) => customFieldSelectors.getDetailEmployerListData(state, { part: "filter" }));
    const pageSort = useSelector((state) => customFieldSelectors.getDetailEmployerListData(state, { part: "sort" }));
    const PaginationData = useSelector(customFieldSelectors.getDetailEmployerPaginationData);
    const params = useParams();

    useEffect(() => {
        return () => {
            dispatch(customFieldActions.setDetailEmployerListSort([{ id: "id", desc: true }]));
            dispatch(customFieldActions.setDetailEmployerListFilter([]));
            dispatch(customFieldActions.setDetailEmployerListPageSize(10));
        };
    }, []);

    const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
        dispatch(customFieldActions.setDetailEmployerListSort(sortBy));
        dispatch(customFieldActions.setDetailEmployerListFilter(filters));
        dispatch(customFieldActions.setDetailEmployerListPageSize(pageSize));
        dispatch(customFieldActions.fetchDetailsEmployersList(+params.id, pageIndex));
    }, []);

    return (
        <>
            <div className={classes.tableWrapper}>
                <ReactTable
                    {...sharedReactTableProps}
                    fetchData={fetchData}
                    data={employersData}
                    defaultFilter={pageFilter}
                    currentPage={PaginationData.currentPage}
                    defaultPageSize={PaginationData.pageSize}
                    loading={PaginationData.isLoading}
                    pageCount={PaginationData.totalCount}
                    defaultSort={pageSort}
                    columns={columns}
                    classes={classNames(sharedReactTableProps.classes, classes.table)}
                />
            </div>
        </>
    )
}
